import React from "react";

import Boton from "../comun/Boton";
import Pagina from "../comun/Pagina";

const PaginaAdelanteAtras =(props) =>{
    const onSubmit = (data)=>{        
        console.log("onsubmit invocado data de la pagina")
        console.log(data)
        props.setState(data);
        props.avanzarPagina();
    }

    return (
        <Pagina 
        onSubmit={onSubmit}
        botonesNavegacion={<BotonesAdelanteAtras retrocederPagina={props.retrocederPagina}/>}
        {...props}/>
    )
}

export default PaginaAdelanteAtras;

const BotonesAdelanteAtras = ({retrocederPagina}) => {
    return (        
        <div style={{marginBottom:"10px"}}>        
            <Boton texto="Anterior" onClick={retrocederPagina} />
            &nbsp;              
            <Boton texto="Siguiente" tipo="submit" />
        </div>
    )
}